// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.history-description-collapsible {
  box-shadow: none;
  margin-bottom: 0;
}
.history-description-collapsible .pui-collapsible__content {
  background-color: rgba(0, 0, 0, 0);
}
.history-description-collapsible .pui-collapsible__header {
  text-align: center;
  display: inherit;
  background-color: revert;
}

.change-request-history {
  margin-bottom: 8rem;
}
.change-request-history .first-load-card {
  border-radius: 5px;
  box-shadow: 0 1.2px 2px rgba(0, 0, 0, 0.2);
  background: white;
}
.change-request-history .loading-card {
  background: white;
}
.change-request-history .change-request-history-table {
  white-space: nowrap;
}
.change-request-history .change-request-history-table .table-responsive {
  margin-bottom: unset;
}
.change-request-history .change-request-history-table .row {
  margin-left: unset;
  margin-right: unset;
}
.change-request-history .change-request-history-table label {
  display: inline-block;
}
.change-request-history .change-request-history-table .page-link {
  background-color: unset;
  border: unset;
  padding: unset;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
